
const HasMetafieldDefinitions = {
  "name": "HasMetafieldDefinitions",
  "kind": "INTERFACE",
  "fieldBaseTypes": {
    "metafieldDefinitions": "MetafieldDefinitionConnection"
  },
  "possibleTypes": ["Collection", "Customer", "DiscountAutomaticNode", "DiscountCodeNode", "DiscountNode", "Location", "Order", "Product", "ProductVariant"]
};
export default HasMetafieldDefinitions;